export default {
	tenantId: "prive_demo",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "prive--demo"
	}
}
